<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
}
</script>

<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
#app {
  height: 100%;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 18px;
  color: @font-main-color;
  overflow: hidden;
}
* {
  box-sizing: border-box;
}
</style>
